import withErrorCheck from "../CheckError";
import server from "../Server";
import type { GetGroupTopGoalsPayload, ITopGoals } from "@grassrootly/api/entities";

// Fetch top 10 goal scorers for a group from player_games_view
export const GetGroupTopGoals = async ({ groupId }: GetGroupTopGoalsPayload): Promise<ITopGoals[]> => {
  const response = await server
    .from("player_games_view")
    .select([
      "player_id",
      "player_name", 
      "player_profile_picture",
      "player_goals_scored",
      "game_datetime",
      "game_id"
    ].join(","))
    .eq("group_id", groupId)
    .gt("player_goals_scored", 0) // Only include games where goals were scored
    .order("player_goals_scored", { ascending: false })
    .order("game_datetime", { ascending: false }) // Secondary sort by most recent
    .limit(10);

  const data = withErrorCheck<ITopGoals[]>(response as any) || [];
  return data;
};
